<template>
  <div class="order-step">
    <next-prev-menu
      :disabled="error || fileListStore.isUploading"
      :previous="true"
      :nextColor="[rootStore.theme.actionColor, 'white']"
      title="Bestelling afronden"
      @next-step="submitOrder"
      @prev-step="$router.push({ name: 'printOrderInvoice' })"
    ></next-prev-menu>

    <div :class="{ 'two-col-res': showPrintStoreAd }" class="auto-height">
      <div>
        <div class="card">
          <div class="confirm-card">
            <div class="error-text main-error" v-if="error > 0 && !submitting">
              Let op, niet alle gegevens zijn volledig of correct ingevuld.
            </div>

            <div class="card-2col">
              <deliver
                :order="order"
                :order-type="order.orderType"
                :print-store-only="printStoreOnly"
                :combi-order="combiOrder"
                :hide-date="custom.hideDeliveryDates"
                :hide-errors="submitting"
                @addError="addError"
                @removeError="removeError"
                @goTo="$router.push({ name: 'printOrderDeliver' })"
              ></deliver>
              <invoice
                :order="order"
                :hide-errors="submitting"
                @goTo="$router.push({ name: 'printOrderInvoice' })"
                @addError="addError"
                @removeError="removeError"
              ></invoice>
            </div>
            <div class="instruction-holder full" v-if="cartV2">
              <button
                class="white-pill-s"
                v-if="order.instruction.length < 1 && !showInstruction"
                @click="showInstruction = true"
              >
                Heeft u nog opmerkingen bij deze opdracht? Klik dan hier.
              </button>
              <div v-else>
                <h3>Opmerkingen bij deze opdracht</h3>
                <textarea
                  class="instruction-text grey-field"
                  :value="order.instruction"
                  @input="
                    printOrderStore.updateOrderDetails(
                      'instruction',
                      $event.target.value
                    )
                  "
                  :placeholder="'Typ hier uw opmerking bij deze opdracht'"
                >
                </textarea>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="showPrintStoreAd && !isMobile">
        <div class="card card-front sub-card">
          <printstore-sidebar-ad :max-count="6"></printstore-sidebar-ad>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-default">
        <div class="title-container files-title">
          <h3 v-if="fileList.length > 0 || printStoreProducts.length > 0">
            {{ printsTitle }}
          </h3>
          <h3
            v-else-if="!submitting"
            class="error-text no-files-error pointer"
            @click="$router.push({ name: 'printOrder' })"
          >
            Bestanden ontbreken nog, klik hier.
          </h3>
          <button
            class="white-pill-s right-btn"
            @click="$router.push({ name: 'printOrder' })"
          >
            Bewerken
          </button>
        </div>

        <ul class="v2-products-list" v-if="custom.printOrder?.cartV2">
          <li v-for="file in fileList" :key="file.fileName">
            <cart-v2-product
              :file="file"
              :hide-specs="hideSpecs"
              :hide-errors="submitting"
              :view-only="true"
              @no-product="$router.push({ name: 'printOrder' })"
            ></cart-v2-product>
          </li>
        </ul>
        <ul class="card-list print-file-list" v-else>
          <li v-for="file in fileList" :key="file.fileName">
            <list-item
              :file="file"
              :hide-specs="hideSpecs"
              :view-only="true"
            ></list-item>
          </li>
        </ul>

        <ul class="card-list print-file-list">
          <li
            v-for="(product, index) in printStoreProducts"
            :key="index"
            class="product"
          >
            <print-store-product
              class="product-item"
              :product="product"
              :view-only="true"
            ></print-store-product>
          </li>
        </ul>

        <div
          class="instruction-holder"
          v-if="(hideSpecs || order.instruction.length > 0) && !cartV2"
        >
          <div class="title-container">
            <h3 class="system-text">Instructies voor de printshop</h3>
          </div>
          <p
            class="pointer"
            v-if="hideSpecs && !order.instruction && !submitting"
          >
            <span
              @click="$router.push({ name: 'printOrder' })"
              class="error-text"
              >Instructies ontbreken nog, klik hier.</span
            >
          </p>
          <p class="instruction-text">{{ order.instruction }}</p>
        </div>
      </div>
      <div class="confirm-footer">
        <legal class="legal"></legal>

        <next-button
          label="Bestelling afronden"
          :disabled="error || fileListStore.isUploading"
          :background-color="rootStore.theme.actionColor"
          :text-color="'white'"
          @click="submitOrder"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Deliver from '@/components/confirm/Deliver.vue'
import ListItem from './ListItem.vue'
import PrintStoreProduct from './printstore/Product.vue'
import Invoice from '@/components/confirm/Invoice.vue'
import Legal from '@/components/confirm/Legal.vue'
import CartV2Product from './CartV2Product.vue'
import PrintstoreSidebarAd from '@/components/PrintstoreSidebarAd.vue'

import { mapStores } from 'pinia'
import { EventBus } from '@/eventbus/EventBus'
import { sortBy } from 'lodash-es/collection'
import NextPrevMenu from '../../../components/NextPrevMenu.vue'
import { useFileListStore } from '@/stores/FileList.store'
import { usePrintOrderStore } from '@/features/printOrder/PrintOrder.store'
import { usePrintStoreStore } from '@/features/printstore/PrintStore.store'
import NextButton from '@/components/NextButton.vue'

export default {
  data() {
    return {
      showInstruction: false,
      submitting: false
    }
  },
  components: {
    Deliver,
    Invoice,
    Legal,
    ListItem,
    PrintStoreProduct,
    PrintstoreSidebarAd,
    NextPrevMenu,
    CartV2Product,
    NextButton
  },
  methods: {
    submitOrder() {
      EventBus.emit('submitOrder')
    },
    onOrderSubmitting() {
      this.submitting = true
    },
    onOrderFailed() {
      this.submitting = false
    },
    addError(val) {
      this.printOrderStore.addOrderError(val)
    },
    removeError(val) {
      this.printOrderStore.removeOrderError(val)
    },
    validateFiles() {
      if (this.submitting) return
      if (
        this.fileListStore.fileList.length > 0 &&
        this.hideSpecs &&
        !this.order.instruction
      ) {
        this.printOrderStore.addOrderError('fileError')
      } else if (this.totalFiles === 0) {
        this.printOrderStore.addOrderError('fileError')
      } else if (
        this.custom.printOrder?.cartV2 &&
        this.fileListStore.fileList.some((file) => !file.productSpecs.title)
      ) {
        this.printOrderStore.addOrderError('fileError')
      } else {
        this.printOrderStore.removeOrderError('fileError')
      }
    }
  },
  computed: {
    ...mapStores(usePrintStoreStore, useFileListStore),
    isMobile() {
      return this.rootStore.isMobile
    },
    printOrderStore() {
      return usePrintOrderStore()
    },
    order() {
      return this.printOrderStore.orderDetails
    },
    custom() {
      return this.rootStore.theme.customFields
    },
    fileList() {
      return this.fileListStore.fileList
    },
    printStoreProducts() {
      return sortBy(this.printStoreStore.orderDetails.cart, ['fileName'])
    },
    hideSpecs() {
      if (this.custom.printSpecs.hide || this.rootStore.interaction.hideSpecs) {
        return true
      } else {
        return false
      }
    },
    printsTitle() {
      return 'Wat wij voor u gaan maken'
    },
    totalFiles() {
      return this.fileList.length + this.printStoreProducts.length
    },
    showPrintStoreAd() {
      return (
        this.rootStore.interactions.some(
          (ia) => ia.destination === 'printStore'
        ) && !this.custom.printStoreAd.hideAds
      )
    },
    printStoreOnly() {
      return (
        this.printStoreStore.orderDetails.cart.length > 0 &&
        this.fileListStore.fileList.length === 0
      )
    },
    combiOrder() {
      return (
        this.printStoreStore.orderDetails.cart.length > 0 &&
        this.fileListStore.fileList.length > 0
      )
    },
    error() {
      return !this.submitting && this.printOrderStore.orderErrors.length > 0
    },
    cartV2() {
      if (this.custom.printOrder?.cartV2) {
        return true
      } else {
        return false
      }
    }
  },
  created() {
    this.validateFiles()
    EventBus.on('orderSubmitting', this.onOrderSubmitting)
    EventBus.on('orderFailed', this.onOrderFailed)
  },
  unmounted() {
    EventBus.off('orderSubmitting', this.onOrderSubmitting)
    EventBus.off('orderFailed', this.onOrderFailed)
  },
  watch: {
    fileList: {
      handler() {
        this.validateFiles()
      },
      deep: true
    },
    totalFiles() {
      this.validateFiles()
    },
    'order.instruction'() {
      this.validateFiles()
    }
  }
}
</script>

<style lang="scss" scoped>
.card .card-2col {
  min-height: auto;
  align-items: start;
}

.card .card-default {
  min-height: auto;
}

.instruction-text {
  word-break: break-word;
}

.two-col-res {
  margin-bottom: 10px;
}

.options-title {
  margin-bottom: 16px;
}

.v2-products-list {
  margin-top: 20px;
}

.instruction-text {
  width: 100%;
  margin-top: 10px;
  height: 130px;
}
</style>
